import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { ConfirmationDialogOptions } from "./confirmation-dialog";
import { ConfirmationDialogComponent } from "./confirmation-dialog.component";


@Injectable()
export class ConfirmationDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Confirmation Dialog Service Call

    Open(options?: ConfirmationDialogOptions): Observable<boolean> {
        const dlgoptions: MatDialogConfig<any> = {
            disableClose: true,
            data: {
                TitleText: 'Confirmation Required...',
                MessageText: '',
                OKText: 'OK',
                CancelText: 'Cancel',
                ...options,
            },
            panelClass: 'confdialog',
            maxWidth: '450px',
            maxHeight: '85vh',
        };

        // if (self.smallMediaSize) {
        //     dlgoptions.panelClass = ['confdialog', 'smalldialogpanel'];
        // }

        const openHandle = this.matDialog.open<ConfirmationDialogComponent>(ConfirmationDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }
}